import { Action } from 'redux';

import { EnterPublishedConnectionTableSubspace } from '~src/bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '~src/bootstrap/redux/actions/isActionFactory';
import { IPublishedConnectionTableDetailInfo } from '~src/publishedConnectionTable/models/IPublishedConnectionTableInfo';
import { PublishedConnectionTableSubspaceName } from '~src/spacesPlatform/state/SpaceInfo';

export interface EnterPublishedConnectionTableSubspaceReduxAction extends Action {
  readonly publishedConnectionTableDetailInfo: IPublishedConnectionTableDetailInfo;
  readonly subspaceName: PublishedConnectionTableSubspaceName;
  readonly requestContent: boolean;
}

export function enterPublishedConnectionTableSubspace(
  publishedConnectionTableDetailInfo: IPublishedConnectionTableDetailInfo,
  subspaceName: PublishedConnectionTableSubspaceName,
  requestContent: boolean,
): EnterPublishedConnectionTableSubspaceReduxAction {
  return {
    type: EnterPublishedConnectionTableSubspace,
    publishedConnectionTableDetailInfo,
    subspaceName,
    requestContent
  };
}

export const isEnterPublishedConnectionTableSubspaceAction = isActionFactory<EnterPublishedConnectionTableSubspaceReduxAction>(EnterPublishedConnectionTableSubspace);
